<div class="modal-overlay" *ngIf="showModalPasta" (click)="!loading && fecharModalPasta()">
  <div class="box-nova-pasta" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-suitcase"></i> Nova Pasta
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModalPasta()" aria-label="Close" [disabled]="loading"></button>
      </div>
    </div>
    <hr>
    <div class="modal-body p-0">
      <div class="row">
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="descricaoPasta">Descrição</label>
            <input type="text" class="form-control" name="descricao" id="descricaoPasta"
                   [(ngModel)]="pasta.descricao" placeholder="Digite o nome da pasta" [disabled]="loading">
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12 d-flex justify-content-start gap-2">
          <button type="button" class="btn btn-primary px-4 d-flex align-items-center gap-2" (click)="salvarModalPasta()" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            {{ loading ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
